import { Lightbulb, MessageCircle, Presentation, Globe } from 'lucide-react';

// Global app-like bottom navigation. Igor round-3: «Шоукейс» replaced by «Идеи»
// — a toggle button that opens the ИДЕИ overlay (tap again returns to the
// showcase flow). The other three stay as links. Liquid-glass styling lives in
// `.bottom-nav` (index.css). Swap `presentation` URL once Igor supplies it.

interface NavLink {
  id: string;
  label: string;
  icon: typeof MessageCircle;
  href: string;
  external: boolean;
}

const NAV_LINKS: NavLink[] = [
  {
    id: 'contacts',
    label: 'Связаться',
    icon: MessageCircle,
    href: 'https://t.me/igorselenov',
    external: true,
  },
  {
    id: 'presentation',
    label: 'Презентация',
    icon: Presentation,
    href: '#presentation', // TODO Igor — replace with the deck URL
    external: false,
  },
  {
    id: 'site',
    label: 'Сайт',
    icon: Globe,
    href: 'https://rafl.digital',
    external: true,
  },
];

interface BottomNavProps {
  ideasOpen: boolean;
  onIdeasToggle: () => void;
}

export function BottomNav({ ideasOpen, onIdeasToggle }: BottomNavProps) {
  return (
    <nav className="bottom-nav" aria-label="Основная навигация">
      <button
        type="button"
        className={`bottom-nav__item${ideasOpen ? ' is-active' : ''}`}
        onClick={onIdeasToggle}
        aria-pressed={ideasOpen}
        aria-label="Идеи"
      >
        <Lightbulb className="bottom-nav__icon" strokeWidth={1.5} />
        <span className="bottom-nav__label">Идеи</span>
      </button>

      {NAV_LINKS.map((item) => {
        const Icon = item.icon;
        return (
          <a
            key={item.id}
            className="bottom-nav__item"
            href={item.href}
            target={item.external ? '_blank' : undefined}
            rel={item.external ? 'noopener noreferrer' : undefined}
            aria-label={item.label}
          >
            <Icon className="bottom-nav__icon" strokeWidth={1.5} />
            <span className="bottom-nav__label">{item.label}</span>
          </a>
        );
      })}
    </nav>
  );
}
